export const DISCOVERY_HOST = 'discovery.haastia.com';

// Production serves Discovery on its own subdomain; local builds preview it at /discovery.
export const DISCOVERY_URL = process.env.NODE_ENV === 'production' ? `https://${DISCOVERY_HOST}/` : '/discovery';

export const isDiscoveryHost = () =>
  typeof window !== 'undefined' && window.location.hostname === DISCOVERY_HOST;

// The subdomain serves only the directory, so its links leave for www. The local
// preview shares an origin with the rest of the app and stays on it.
export const mainSiteUrl = (path = '/') => (isDiscoveryHost() ? `https://www.haastia.com${path}` : path);
